export default __webpack_public_path__ + "static/media/251.d0d07cfa.jpg";